import { environment } from 'environments/environment';
import { KeycloakService } from 'keycloak-angular';

export function initializer(keycloak: KeycloakService): () => Promise<boolean> {
        return async (): Promise<boolean> => {
                return keycloak.init({
                        config: environment.auth,
                        loadUserProfileAtStartUp: true,
                        enableBearerInterceptor: true,
                        shouldAddToken: (req) => req.url.startsWith(environment.url),
                        initOptions: {
                                checkLoginIframe: false,
                                enableLogging: true,
                                onLoad: 'login-required',
                                // silentCheckSsoRedirectUri:
                                //      window.location.origin + '/assets/silent-check-sso.html',
                        },
                });
        };
}
